// extracted by mini-css-extract-plugin
export default {"brandPrimary":"CatalogConfirmModals_brandPrimary__3zGcY"};